import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import Loader from "../../../../components/Loader/Loader";

const TotalPatientCharts = ({ data, loading }) => {
  const [chartSeries, setChartSeries] = useState([]);
  const [maxYAxis, setMaxYAxis] = useState(0);
  const [chartCategories, setChartCategories] = useState([]);

  useEffect(() => {
    if (data) {
      const seriesData = Object.values(data);
      const maxValue = Math.max(...seriesData) + 20;

      setMaxYAxis(maxValue);
      setChartSeries([{ 
        name: "Patient Registered",
        data: seriesData 
      }]);

      const categories = Object.keys(data).map((date) => {
        // Extract year and month
        const [year, month] = date.split("-");
        return `${month.substring(0, 3)} ${year}`; 
      });
      setChartCategories(categories);
    }
  }, [data]);

  const options = {
    chart: {
      type: "bar",
      height: "100%",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
        }
      },
      fontFamily: 'inherit',
    },
    title: {
      text: 'Monthly Patient Registration',
      align: 'center',
      style: {
        fontSize: '16px',
        fontWeight: 600,
        fontFamily: 'inherit',
        color: '#333'
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
        borderRadius: 4,
        distributed: false,
      },
    },
    colors: ['#3384ef'],
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: chartCategories,
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: 'inherit',
        },
        rotateAlways: false,
        hideOverlappingLabels: true,
      },
      axisBorder: {
        show: true,
        color: '#e0e0e0',
      },
      axisTicks: {
        show: true,
        color: '#e0e0e0',
      },
    },
    yaxis: {
      title: {
        text: "Patients",
        style: {
          fontSize: '14px',
          fontFamily: 'inherit',
        },
      },
      max: maxYAxis,
      labels: {
        formatter: function(val) {
          return Math.round(val);
        },
        style: {
          fontSize: '12px',
          fontFamily: 'inherit',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    grid: {
      borderColor: '#f1f1f1',
      row: {
        colors: ['transparent', 'transparent'],
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " patients";
        },
      },
      theme: "light",
      style: {
        fontSize: '12px',
        fontFamily: 'inherit'
      },
      marker: {
        show: true,
      },
    },
    responsive: [
      {
        breakpoint: 1400,
        options: {
          chart: {
            height: 300,
          }
        }
      },
      {
        breakpoint: 992,
        options: {
          chart: {
            height: 280,
          },
          plotOptions: {
            bar: {
              columnWidth: '60%',
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 250,
          },
          xaxis: {
            labels: {
              rotate: -45,
              rotateAlways: true,
            }
          }
        },
      },
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 220,
          },
          plotOptions: {
            bar: {
              columnWidth: '70%',
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
              offsetY: 0,
              style: {
                fontSize: '10px',
              }
            }
          },
          yaxis: {
            title: {
              text: "",
            },
          }
        },
      },
    ],
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="w-full h-[300px] sm:h-[320px] md:h-[350px]">
      <ReactApexChart options={options} series={chartSeries} type="bar" height="100%" width="100%" />
    </div>
  );
};

export default TotalPatientCharts;